import { optionTitle_schedulingOptions } from './ResourceScheduling.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { ALLOWED_OPTION_KEYS } from './ResourceSchedulingConstants';
import { isFeatureEnabled } from 'owa-feature-flags';

const lazyFullModule = new LazyModule(() => import('./lazySchedulingOptionsFullOption'));
const ResourceSchedulingOption: LazyOption = createLazyOption(
    {
        key: 'resourceSchedulingOption',
        titleStringKey: optionTitle_schedulingOptions,
        searchTermsStringKey: optionTitle_schedulingOptions,
        isHidden: () => {
            return !isFeatureEnabled('cal-mf-resourceSchedulingSetting');
        },
        allowedOptionKeys: ALLOWED_OPTION_KEYS,
    },
    lazyFullModule,
    m => m.default
);
export default ResourceSchedulingOption;
